// Authenticated index — redirects to `/inbox` (US-045).
//
// `/` lands on the inbox by default. The wizard takes over via
// `OnboardingRedirect` for fresh users; once complete, the inbox is the
// daily-driver landing surface for every goal type.

import { createRoute, redirect } from '@tanstack/react-router';

import { Route as AuthedLayoutRoute } from './__layout';

export const Route = createRoute({
  getParentRoute: () => AuthedLayoutRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({
      to: '/inbox',
      search: { accountId: undefined, mode: undefined, selectedId: undefined },
      replace: true,
    });
  },
  component: () => null,
});
